import { Injectable } from '@angular/core';
import { ContextUpdate } from './model/context-update';
import { LicenseType } from './model/license-type';
import { LicenseValidityContext } from './model/license-validity-context';
import { Product } from './model/product';

@Injectable({
  providedIn: 'root'
})
export class SerializedProductService {
  deserializeProduct(serializedProduct: Product<string>): Product {
    return {
      ...serializedProduct,
      productCategoryUpdate: this.deserializeContextUpdate(serializedProduct.productCategoryUpdate),
      licenseTypes: this.deserializeLicenseTypes(serializedProduct.licenseTypes)
    };
  }

  private deserializeContextUpdate<T>(productContextUpdate: ContextUpdate<T, string>): ContextUpdate<T, Date> {
    return {
      ...productContextUpdate,
      timestamp: new Date(productContextUpdate.timestamp)
    };
  }

  private deserializeLicenseTypes(licenseTypes: LicenseType<string>[]): LicenseType[] {
    const newLicenseTypes: LicenseType[] = [];
    for (const licenseType of licenseTypes) {
      newLicenseTypes.push({
        ...licenseType,
        validityUpdate: {
          ...this.deserializeContextUpdate(licenseType.validityUpdate),
          context: this.deserializeValidityContext(licenseType.validityUpdate.context),
          timestamp: new Date(licenseType.validityUpdate.timestamp)
        },
        validityChooser:
          licenseType.validityChooser === null
            ? null
            : {
                ...licenseType.validityChooser,
                dateConstraints:
                  licenseType.validityChooser.dateConstraints === null
                    ? null
                    : {
                        ...licenseType.validityChooser.dateConstraints,
                        notBeforeDate: licenseType.validityChooser.dateConstraints.notBeforeDate
                          ? new Date(licenseType.validityChooser.dateConstraints.notBeforeDate)
                          : null,
                        notAfterDate: licenseType.validityChooser.dateConstraints.notAfterDate
                          ? new Date(licenseType.validityChooser.dateConstraints.notAfterDate)
                          : null
                      },
                durationConstraints:
                  licenseType.validityChooser.durationConstraints === null
                    ? null
                    : {
                        ...licenseType.validityChooser.durationConstraints,
                        endBeforeDate: licenseType.validityChooser.durationConstraints.endBeforeDate
                          ? new Date(licenseType.validityChooser.durationConstraints.endBeforeDate)
                          : null
                      }
              }
      });
    }
    return newLicenseTypes;
  }

  private deserializeValidityContext(context: LicenseValidityContext<string> | null): LicenseValidityContext | null {
    return context === null
      ? null
      : {
          ...context,
          date: context.date === null ? context.date : new Date(context.date),
          duration:
            context.duration === 'UNLIMITED' || context.duration === null || typeof context.duration === 'object'
              ? context.duration
              : new Date(context.duration)
        };
  }

  serializeValidityContext(context: LicenseValidityContext | null): LicenseValidityContext<string> | null {
    return context === null
      ? null
      : {
          ...context,
          date: context.date === null ? context.date : context.date.toISOString(),
          duration:
            context.duration === 'UNLIMITED' || context.duration === null || (typeof context.duration === 'object' && 'runtime' in context.duration)
              ? context.duration
              : context.duration.toISOString()
        };
  }
}
